<template>
	<AppModal
		id="rename-mfa-modal"
		:title="$t('Rename 2FA method')"
		@close="closeModal"
		action="Save"
		@cta="save"
		:disableAction="!newName.trim()"
		secondaryAction="Cancel"
		@secondary-cta="closeModal"
	>
		<AppInput
			class="mt-2 mb-1 form-group"
			:placeholder="$t('Enter authenticator name')"
			:error="ajaxError && ajaxError.errors && ajaxError.errors.newName"
			name="authenticator-name"
			v-model="newName"
			@keyup.enter="save"
			:key="stateChangeKey"
		/>
	</AppModal>
</template>

<script>
	export default {
		props: {
			config: {
				type: Object,
				default: () => ({}),
			},
		},
		data() {
			return {
				newName: '',
				ajaxError: {
					message: '',
					status: null,
					errors: {},
				},
				stateChangeKey: 0,
			}
		},
		methods: {
			save() {
				const errorObject = {
					status: 'error',
					message: this.$t('The given data was invalid.'),
					errors: {},
				}
				Object.assign(this.ajaxError, errorObject)

				if (!this.newName.trim()) return
				this.$axios
					.post(
						`v1/mfa/config/${this.config.id}/rename`,
						{ name: this.newName.trim() },
						{
							baseURL: this.$configSettings.authApiUrl,
						}
					)
					.then(response => {
						if (response.status === 200) {
							this.$stanNotify({
								type: 'success',
								text: `Successfully renamed 2FA method!`,
							})

							this.$emit('save')
						} else {
							this.$stanNotify({
								type: 'error',
								text: `Failed to rename 2FA method`,
							})
						}
						this.closeModal()
					})
					.catch(error => {
						this.$logError(error.response.data.message)
						Object.assign(errorObject.errors, {
							newName: [`2FA method name must contain only numbers, letters and punctuation characters`],
						})
						Object.assign(this.ajaxError, errorObject)
						this.stateChangeKey += 1
					})
					.finally()
			},
			show() {
				// Reset to original config name when opening
				this.newName = this.config?.name || ''
				Object.assign(this.ajaxError, { message: '', status: null, errors: {} })
				this.stateChangeKey += 1
				$('#rename-mfa-modal').modal('show')
			},
			closeModal() {
				$('#rename-mfa-modal').modal('hide')
			},
		},
	}
</script>
